import { useNavigate } from 'react-router-dom';
import { Button, StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { SearchX } from 'lucide-react';

/**
 * Page of a route that does not exist inside the shell (e.g. `/settings/profile`, which has no
 * page yet): a StatusMessage and a way back, instead of an empty shell.
 */
const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('core-shell');
  return (
    <div className="flex flex-col items-center gap-3 py-16" data-testid="shell-not-found">
      <StatusMessage icon={SearchX} title={t('notFound.title')} subtitle={t('notFound.subtitle')} />
      <Button variant="secondary" size="md" onClick={() => navigate('/dashboard')}>
        {t('notFound.back')}
      </Button>
    </div>
  );
};

export default NotFoundPage;
